// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-2f7b2e5e]{background-color:var(--v-primary-base)!important;border-radius:50px;color:#fff}.help-info-wrapper[data-v-2f7b2e5e]{display:inline-block;vertical-align:middle;margin-left:1px}qr-address-field[data-v-2f7b2e5e]{width:88%!important}.warp[data-v-2f7b2e5e]{position:relative;overflow:visible!important;min-height:50px}.doublebtn[data-v-2f7b2e5e]{gap:8px}", ""]);
// Exports
module.exports = exports;
